export type Note = {
  id: string
  patientName: string
  patientType: string
  noteType: string
  procedure: string
  procedureStatus: string
  dateOfService: string
  chiefComplaint: string[]
  medicalHistory: string[]
  surgicalHistory: { procedure: string; laterality: string }[]
  fileTime?: string | null
  noteDescription: string
  noteTitle?: string
  pinned?: boolean
}

export type UpdateNoteThunkParams = {
  id: string
  body: Partial<Note>
}

export enum NoteContextType {
  APPOINTMENT = 'appointment',
  BILLING = 'billing',
  CHARTING = 'charting',
  TREATMENT_PLAN = 'treatment_plan',
  CALL = 'call',
  CONTACT = 'contact',
  PATIENT = 'patient',
  PERIO = 'perio',
  CLAIMS = 'claims',
  CLAIM_ITEM = 'claim_item',
  CAMPAIGN = 'campaign',
  FILES = 'files',
  XRAY = 'xray',
  INSURANCE = 'insurance',
  PROVIDER = 'provider',
  FORMS = 'forms',
  CARRIER = 'carrier',
}

/** Included when notes are fetched with appointment join (list/detail API). */
export interface INoteAppointmentSnippet {
  appointment_id?: string
  appt_date?: string | null
  appt_start?: string | null
}

/** Joined user row when notes are fetched with `updatedBy` include (data layer). */
export interface INoteUpdatedByUser {
  user_id: string
  first_name?: string | null
  last_name?: string | null
}

export type NoteTranscriptSegmentRole = 'doctor' | 'patient' | 'unknown'

export interface INoteTranscriptSegment {
  speaker: string
  role: NoteTranscriptSegmentRole
  text: string
  start: number
  end: number
}

export interface INote {
  note_id: string
  note_group_id?: string
  version?: number
  is_latest?: boolean
  patient_id?: string | null
  contact_id?: string | null
  clinic_id: string
  title: string
  body: string
  context_type: NoteContextType
  context_id?: string | null
  context_display_name?: string | null
  context_details?: Record<string, unknown> | null
  transcript_segments?: INoteTranscriptSegment[] | null
  created_by: string
  updated_by?: string | null
  updatedBy?: INoteUpdatedByUser | null
  date_time_created_at?: string
  date_time_updated_at?: string
  appointment?: INoteAppointmentSnippet | null
}

export interface INoteTemplate {
  template_id: string
  clinic_id: string
  name: string
  content: string
  category: string | null
  created_by: string | null
  updated_by: string | null
  date_time_created_at?: string
  date_time_updated_at?: string
}
